<template>
  <div class="secondary-menu-submenu">
    <button :id="id" class="toggle" role="button" @click.prevent="toggle">
      {{ subMenu.text }}
      <span
        :class="[
          'af-icons',
          'af-icons-chevron-' + (isOpen ? 'down' : 'up'),
          'pull-right'
        ]"
      />
    </button>
    <collapsible>
      <sub-menu
        v-if="isOpen"
        id="secondary-submenu"
        :current-url="currentUrl"
        :items="subMenu.children"
        :aria-labelledby="id"
        @itemSelected="item => $emit('itemSelected', item, subMenu)"
      />
    </collapsible>
  </div>
</template>

<script>
import Collapsible from '../Shared/Collapsible';
import SubMenu from './SubMenu';

export default {
  components: {
    Collapsible,
    SubMenu
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true
    },
    subMenu: {
      type: Object,
      default: () => ({})
    },
    currentUrl: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: ''
    }
  },
  methods: {
    toggle() {
      this.$emit('toggled', this.subMenu);
    }
  }
};
</script>
